import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { PRODUCT_LABEL } from './product-label.enum';
import { SharedModule } from "../../helper/shared.module";

@Component({
    selector: 'ig-product-label',
    template: '<span [attr.class]="colorClass" role="emphasis">{{ "PRODUCT_LABEL." + label | uitranslate }}</span>',
    styleUrls: ['./product-label.component.scss'],
    imports: [SharedModule]
})
export class ProductLabelComponent implements OnInit, OnChanges {
  /**
   * The label for the product label
   */
  @Input({ required: true }) label!: PRODUCT_LABEL | string;

  /**
   * @ignore
   */
  protected colorClass = '';

  /**
   * @ignore
   */
  ngOnInit(): void {
    this.#setColors();
  }

  /**
   * @ignore
   */
  ngOnChanges(): void {
    this.#setColors();
  }

  /**
   * @ignore
   */
  #setColors() {
    switch (this.label) {
      case PRODUCT_LABEL.NEW:
      case PRODUCT_LABEL.RECOMMENDED:
      case PRODUCT_LABEL.FREE:
        this.colorClass = 'green';
      break;

      case PRODUCT_LABEL.DEPRECATED:
        this.colorClass = 'red';
      break;

      case PRODUCT_LABEL.DISCONTINUED:
        this.colorClass = 'red';
      break;

      case PRODUCT_LABEL.LABS:
        this.colorClass = 'orange';
      break;

      case PRODUCT_LABEL.UPGRADE:
      case PRODUCT_LABEL.REALTIME_SCALING:
        this.colorClass = 'accent';
      break;
    }
  }

}
